<template src="../../../components/shared/physicianSearch/BaseResult.html">


</template>

<script>
    import {baseResultMixin} from "../../../components/shared/mixins/baseResultMixin.js";
    import {mapGetters} from 'vuex';
    import {common} from "../../../global/common.js";

    export default {
        name: "SearchResult",
        mixins: [baseResultMixin],
        data() {
            return {
                //We can not pass it as a prop because the html is being shared
                companyId: this.additionalData.companyId
            };
        },
        computed: {
            ...mapGetters({showPricing: 'globalSettings/showPricing'})
        },
        async mounted() {
            let detailsUrl = `ProviderSearch/${this.companyId}/getProviderDetailsAndPlans/${this.baseData.providerEntityId}`;
            detailsUrl = common.appendUrlParameter(detailsUrl, 'token', this.additionalData.token);
            await this.baseInit(detailsUrl);
        },
        methods: {
            viewProfile() {
                this.$router.push({
                    name: "physicianProfile", params: {
                        companyId: this.companyId,
                        token: this.additionalData.token,
                        providerEntityId: this.baseData.providerEntityId
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>